import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-undo",
  "use": "gw-undo-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-undo\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M5.54 10.6C7.39 8.99 9.79 8 12.44 8c4.16 0 7.74 2.42 9.44 5.93.32.67-.04 1.47-.75 1.71-.59.2-1.23-.08-1.5-.64-1.3-2.66-4.03-4.5-7.19-4.5-1.95 0-3.73.72-5.12 1.88l1.91 1.91c.63.63.19 1.71-.7 1.71H2.94c-.55 0-1-.45-1-1V9.41c0-.89 1.08-1.34 1.71-.71l1.89 1.9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol